import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React, { Component } from 'react';
import ItemQuantity from './ItemQuantity';
import ItemSelect from './ItemSelect';
import strings from '../components/language/language';

// import orderImage from '../order.jpg';
const styles = theme => ({
  dialogTitle: {
    padding: '15px 25px 10px'
  },
  dialogCustomizedWidth: {
    'max-width': '77%'
  },
  dialogContent: {
    overflowY: 'visible',
    padding: '0 24px 5px'
  },
  button: {
    padding: '20px 110px',
    color: '#fff !important',
    backgroundColor: '#70142b',
    textTransform: 'capitalize',
    margin: '25px auto',
    borderRadius: theme.shape.borderRadius * 6,
    '&:hover': {
      backgroundColor: '#70142b'
    }
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column'
  },
  price: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  orderImage: {
    height: '100%',
    backgroundSize: 'cover'
    // background: `url(${orderImage}) no-repeat center center`
  }
});

class Itempopup extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.props.close}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
          fullWidth
          classes={{ paperFullWidth: classes.dialogCustomizedWidth }}
        >
          <Grid container>
            <Grid item md={6}>
              <div className={classes.orderImage} />
            </Grid>
            <Grid item md={6}>
              <DialogTitle
                className={classes.dialogTitle}
                id='alert-dialog-title'
              >
                <div>
                  <Typography variant='title' gutterBottom>
                    American Chocolate Cake
                  </Typography>
                  <Typography variant='caption' gutterBottom>
                    description
                  </Typography>
                </div>
              </DialogTitle>
              <Divider />
              <DialogContent className={classes.dialogContent}>
                <DialogContentText id='alert-dialog-description'>
                  <div className={classes.price}>
                    <div>
                      <p>Regular price</p>
                    </div>
                    <div>
                      <p>20 {strings.currency}</p>
                    </div>
                  </div>
                </DialogContentText>
                {/* select options */}
                <ItemSelect />
                {/* select options */}
              </DialogContent>
              <div className={classes.buttons}>
                <ItemQuantity />
                <Button className={classes.button}>Add To Cart</Button>
              </div>
            </Grid>
          </Grid>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(Itempopup);



// WEBPACK FOOTER //
// ./src/components/Itempopup.js